import React, { useState } from 'react';
import './App.css';

function App() {
  const [booked, setBooked] = useState(false);

  const handleBook = (e) => {
    e.preventDefault();
    setBooked(true);
  };

  return (
    <div className="app-container">
      <header className="header">
        <div className="logo">🚀 MarsBookings</div>
        <nav>
          <a href="#home">Home</a>
          <a href="#destinations">Destinations</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>

      <main>
        <section id="home" className="hero">
          <h1>Next Stop: Olympus Mons</h1>
          <p>Book your luxury suite on the Red Planet today. Fast rockets, zero-G pools, and crater views.</p>
          <button className="btn" onClick={() => document.getElementById('destinations').scrollIntoView()}>Explore Packages</button>
        </section>

        <section id="destinations" className="destinations">
          <h2>Available Launch Dates</h2>
          <div className="card-grid">
            <div className="card">
              <h3>Ares Valles Resort</h3>
              <p>Launch: Q4 2028</p>
              <p>Price: $450,000</p>
              {booked ? <p className="success">Booking Confirmed!</p> : <button className="btn" onClick={handleBook}>Book Now</button>}
            </div>
            <div className="card">
              <h3>Valles Marineris Camp</h3>
              <p>Launch: Q1 2029</p>
              <p>Price: $380,000</p>
              {booked ? <p className="success">Booking Confirmed!</p> : <button className="btn" onClick={handleBook}>Book Now</button>}
            </div>
          </div>
        </section>
      </main>

      <footer id="contact">
        <p>© 2026 MarsBookings Inc. Interplanetary travel made simple.</p>
        <p><a href="mailto:support@marsbooking.net">support@marsbooking.net</a></p>
      </footer>
    </div>
  );
}

export default App;
